/* eslint-disable import/prefer-default-export */
import Modal from '@deprecated-ui/common/Modal';
import hexOpacity from '@deprecated-ui/utils/hexOpacity';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import Image from 'global/Image';
import styled from 'styled-components';

interface ImageItemProps {
  visible: boolean;
}

interface ActionIconWrapperProps {
  position: 'left' | 'right';
}

const ImageItem = styled(Image)<ImageItemProps>`
  max-height: 100%;
  max-width: 100%;
  height: auto;
  @media ${device.tablet} {
    max-height: 767px;
    max-width: 1389px;
    height: auto;
    width: auto;
  }
  vertical-align: middle;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  background: ${color.light};
`;

const ModalImage = styled(Modal)`
  padding-bottom: 0px !important;
  margin: 0;
  max-width: unset;
  .ant-modal-content {
    position: unset;
    background-color: transparent;
    box-shadow: none;
  }
  .ant-modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const CloseIconWrapper = styled.button`
  display: block;
  position: absolute;
  right: 20px;
  top: 20px;
  border-radius: 50%;
  padding: 10px;
  border: none;
  cursor: pointer;
  background: ${color.black}${hexOpacity(45)};

  p {
    font-size: 19.5px;
  }
`;

const ActionIconWrapper = styled.button<ActionIconWrapperProps>`
  display: block;
  position: absolute;
  top: 50%;
  border-radius: 50%;
  padding: 10px;
  border: none;
  cursor: pointer;
  background: ${color.black}${hexOpacity(45)};
  right: ${({ position }) => (position === 'left' ? 'unset' : '20px')};
  left: ${({ position }) => (position === 'left' ? '20px' : 'unset')};

  p {
    font-size: 19.5px;
  }
`;

export { ImageItem, ModalImage, CloseIconWrapper, ActionIconWrapper };
